"use strict";
// Copyright (c) StrangeBee 2023
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ParentController_1 = __importDefault(require("../ParentController"));
class AuditController extends ParentController_1.default {
    constructor() {
        super(...arguments);
        this.endpoints = {};
    }
}
exports.default = AuditController;
